module.exports = __webpack_public_path__ + "console/img/news.d63f1b04.svg";